import { render, staticRenderFns } from "./BattlesOverview.vue?vue&type=template&id=76122554&scoped=true"
import script from "./BattlesOverview.vue?vue&type=script&lang=js"
export * from "./BattlesOverview.vue?vue&type=script&lang=js"
import style0 from "./BattlesOverview.vue?vue&type=style&index=0&id=76122554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76122554",
  null
  
)

export default component.exports